import { useEffect, useState } from 'react';

import { post } from '../../lib/api';
import type { ApplicationType } from '../../lib/applications';
import type { SelectOption } from '../form';
import type { MappingMode } from './ModeToggle';

// Admin "edit mapping" helper shared by the SmartStore and Jasper tabs: scopes
// the instance picker to the instances the selected user is actually mapped to,
// and auto-selects the single instance a local user has. Returns '' for
// editInstance when there's nothing (or more than one) to choose yet.
export function useUserInstances(mode: MappingMode, editUser: string, appType: ApplicationType) {
    const [userInstances, setUserInstances] = useState<SelectOption[]>([]);
    const [editInstance, setEditInstance] = useState('');

    useEffect(() => {
        if (mode !== 'edit' || !editUser) {
            setUserInstances([]);
            setEditInstance('');
            return;
        }
        post<string[]>('home/GetUserInstances', { email: editUser, appType })
            .then((r) => {
                const opts = (r.data ?? []).map((d) => ({ value: d, label: d })).sort((a, b) => a.label.localeCompare(b.label, 'nb'));
                setUserInstances(opts);
                setEditInstance(opts.length === 1 ? opts[0].value : '');
            })
            .catch(() => {
                setUserInstances([]);
                setEditInstance('');
            });
        // appType is a fixed enum constant per call site; re-run on mode/user only.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mode, editUser]);

    return { userInstances, editInstance, setEditInstance };
}
